import { Injectable } from '@angular/core';
import { IMap } from '@nimbus-library/features/shared/models/interfaces';
import { IErrorStatus } from '@nimbus-global/features/shared/models/api/i-error-status.model';
import { IErrorHandlerOption } from './error-handler.service';

@Injectable()
export abstract class BaseErrorCodeProviderService {
  public abstract getErrorCodes(): IMap<(x: IErrorStatus) => IErrorHandlerOption>;
}
